import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-projects',
  template: `
    <div class="t-row">
      <h1 class="text-muted"><i class="bi bi-files"></i> Projects</h1>
      <div class="cards">
        <!--  -->
        <div
          *ngFor="let p of projects; let i = index"
          class="card mb-3"
          style="max-width: 540px;"
        >
          <h1 class="text-muted">{{ i + 1 }}</h1>
          <div class="row g-0">
            <div class="col-md-4">
              <div class="img-fluid rounded-start"></div>
            </div>
            <div class="col-md-8">
              <div class="card-body">
                <h5 class="card-title">{{ p.title }}</h5>
                <p class="card-text">
                  {{ p.desc }}
                </p>
                <p class="card-text">
                  <small class="d-block text-muted">tech stack used</small>
                  <span
                    *ngFor="let s of p.stack"
                    class="badge rounded-pill bg-warning text-dark"
                    >{{ s }}</span
                  >
                </p>
              </div>
              <div class="card-body">
                <a [href]="p.github" class="card-link"
                  ><i class="bi bi-github"></i
                ></a>
                <a [href]="p.link" class="card-link" target="blank"
                  >visit <i class="bi bi-arrow-up-right-circle-fill"></i
                ></a>
              </div>
            </div>
          </div>
        </div>
        <!--  -->
      </div>
    </div>
  `,
  styles: [
    `
      .t-row {
        display: flex;
        flex-direction: column;
        align-items: center;
      }
      h1 {
        margin: 0 0 1em 1.5em;
        align-self: flex-start;
      }
      .col-md-4 {
        background: orange;
      }
      .card {
        position: relative;
      }
      .card h1 {
        position: absolute;
        left: -220px;
        top: 0;
        font-size: 11em;
        z-index: 1;
        color: rgba(0, 0, 0, 0.1) !important;
      }
    `,
  ],
})
export class ProjectsComponent implements OnInit {
  projects: any[] = [
    {
      image: 'assets/images/yelpcamp.png',
      title: 'YelpCamp',
      desc: 'A superficial camping website. Users can share campgrounds, comment on posted camps',
      stack: ['Nodejs', 'ExpressJs', 'MongoDB', 'SemanticUI'],
      github: 'https://github.com/JamalGuyo/YelpCamp',
      link: 'https://yelp-camplife.herokuapp.com/',
    },
    {
      image: 'assets/images/bnb.png',
      title: 'AirBnB Clone',
      desc: 'A simple location based bed and breakfast finder',
      stack: ['ReactJs'],
      github: 'https://github.com/JamalGuyo/airbnb-clone',
      link: 'https://morning-stream-95568.herokuapp.com/',
    },
    {
      image: 'assets/images/todo.png',
      title: 'ToDo App',
      desc: 'A simple CRUD todo application',
      stack: ['NodeJs', 'MongoDB', 'ExpressJs'],
      github: 'https://github.com/JamalGuyo/todolist',
      link: 'https://todo-node-demo.herokuapp.com/',
    },
    {
      image: 'assets/images/todo.png',
      title: 'Movie App',
      desc: "A simple movie app using OMDB Api. The app let's you search for any movie by title",
      stack: ['Angular', 'Bootstrap5', 'OmdbAPI'],
      github: 'https://github.com/JamalGuyo/LloydInterview',
      link: 'https://lloyd-interview.vercel.app/search',
    },
  ];
  constructor() {}

  ngOnInit(): void {}
}
